import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  color?: string;
  className?: string;
};

export const S26 = ({ size = 2, color = 'currentColor', className }: Props) => {
  return (
    <svg
      style={{
        width: unitMapping[size],
      }}
      viewBox="0 0 76 48"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M54.3898 23.4236H45.6522V38.1804H54.3898V23.4236Z"
        fill={color}
      />
      <path
        d="M12.141 -0.0022583L0.227051 11.3093V47.8877H61.6889L75.4998 36.606V-0.0022583H12.1361H12.141ZM34.5103 21.1522L20.8637 30.9502V38.0598H34.5103V42.1971H15.5116V28.7546L29.1582 18.9864V8.44159H20.8637V16.8157H15.5116V11.155C15.5116 6.37544 18.1752 4.14997 24.996 4.14997C31.8168 4.14997 34.5053 6.37046 34.5053 11.155V21.1572L34.5103 21.1522ZM59.7373 16.1635H54.3852V8.43661H45.6725V21.8243C47.2208 20.1166 49.6256 19.315 52.5978 19.315C56.8895 19.315 59.7323 21.4609 59.7323 25.8819V35.4709C59.7323 40.3052 56.994 42.5008 50.0139 42.5008C43.0338 42.5008 40.2955 40.3052 40.2955 35.4709V11.145C40.2955 6.33561 43.2429 4.14001 50.0139 4.14001C56.7849 4.14001 59.7323 6.33561 59.7323 11.1699V16.1586L59.7373 16.1635Z"
        fill={color}
      />
    </svg>
  );
};
